import { GzRuleSettingsWebComponent } from './component/GzRuleSettingsWebComponent';
export { GzRuleSettingsWebComponent };
